import https from '../utils/httpPot.js'

// 登录获取token
export function loginPot(params) {
    return https.post(`/api/getToken`, params);
}

// 退出行为记录
export function behaviorloginOut(params) {
  return https.post(`/api/behavior/loginOut`, params);
}
// 退出行为记录
export function behaviorlogin(params) {
  return https.post(`/api/behavior/login`, params);
}
// 搜索行为记录
export function searchPot(params) {
  return https.post(`/api/behavior/search`, params);
}

// 浏览行为记录
export function behaviorbrowse(params) {
  return https.post(`/api/behavior/browse`, params);
}
// 下单行为记录
export function behaviorplaceOrder(params) {
  return https.post(`/api/behavior/placeOrder`, params);
}

// 收藏行为记录
export function behaviorcollect(params) {
  const val = JSON.parse(localStorage.getItem('line')) || {}
  if(val.source_type != 8){
    params.source_type = val.source_type
    params.source_info = val.source_info
    params.login_device = '3'
    params.is_view_details ? '' :params.is_view_details = 0
    return https.post(`/api/behavior/collect`, params);
  }

}

//用户访问页面记录---新

export function behaviorUserPageAccess(params = {}) {
  if(!params.source_type){
    const val = JSON.parse(localStorage.getItem('line')) || {}
    params.source_type = val.source_type || ''
    params.source_info = val.source_info || ''
  }
  if(params.source_info == 0){
    params.source_info='首页'
  }
  params.login_device = 3
  params.page_number ? '' : params.page_number = 1
  params.ip = localStorage.getItem('ipAddress')

  return https.post(`/api/behavior/userPageAccess`, params);
}

// 加购行为记录
export function behaviorshopCart(params) {

  const val = JSON.parse(localStorage.getItem('line')) || {}
  if(val.source_type!=8){
    params.source_type = val.source_type
    params.source_info = val.source_info
    params.login_device = '3'
    params.is_view_details ? '' :params.is_view_details = 0

    return https.post(`/api/behavior/shopCart`, params);
  }

}

// 页面访客记录
export function behaviorpageAccess(params) {
  params.login_device = '3'
  return https.post(`/api/behavior/pageAccess`, params);
}



// 获取ip地址
localStorage.getItem('ipAddress') ?'':fetch('https://ipinfo.io/json')
.then(response => response.json())
.then(data => {
  const ipAddress = data.ip;
  localStorage.setItem('ipAddress', ipAddress);
})
.catch(error => {
  console.error('Error fetching IP address:', error);
})


// 存行为
export function lineLocal(params) {
  localStorage.setItem('line', JSON.stringify(params));
}



// WEBPACK FOOTER //
// ./src/api/apiPot.js